import { useState } from 'react'
import { Document } from '@contentful/rich-text-types'

import AccordionItem from './accordion-item'

type FaqProps = {
  question: string
  answer: Document | string
}

export default function Faq({ question, answer }: FaqProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <AccordionItem
      title={question}
      content={answer || ''}
      isOpen={isOpen}
      onToggle={setIsOpen}
    />
  )
}
